import { useMutation, useQueryClient } from "@tanstack/react-query";
import { timeEntryApi } from "../service";
import { timeEntryKeys } from "../time-entry.keys";

export function useDeleteTimeManagement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) =>
      timeEntryApi.deleteTimeManagement(id).then((r) => r.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: timeEntryKeys.lists() });
    },
  });
}
